import { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedLayout } from './pages/ProtectedLayout';
import { ROUTES } from './lib/routes';
import { MemoraiSkeleton } from './lib/components/memorai';

const Login = lazy(() => import('./pages/Login').then((module) => ({ default: module.Login })));
const CaptureView = lazy(() => import('./pages/CaptureView').then((module) => ({ default: module.CaptureView })));
const NoteDetailView = lazy(() => import('./pages/NoteDetailView').then((module) => ({ default: module.NoteDetailView })));
const SearchView = lazy(() => import('./pages/SearchView').then((module) => ({ default: module.SearchView })));
const CategoriesView = lazy(() => import('./pages/CategoriesView').then((module) => ({ default: module.CategoriesView })));
const MoreView = lazy(() => import('./pages/MoreView').then((module) => ({ default: module.MoreView })));
const BinView = lazy(() => import('./pages/BinView').then((module) => ({ default: module.BinView })));

function PageFallback() {
    return (
        <div className="w-full max-w-4xl mx-auto p-6 space-y-4">
            <MemoraiSkeleton className="h-10 w-40 rounded-xl" />
            <MemoraiSkeleton className="h-28 w-full rounded-2xl" />
            <MemoraiSkeleton className="h-28 w-full rounded-2xl" />
        </div>
    );
}

export default function App() {
    return (
        <Suspense fallback={<PageFallback />}>
            <Routes>
                {/* Public Routes */}
                <Route path={ROUTES.LOGIN} element={<Login />} />

                {/* Protected Routes */}
                <Route element={<ProtectedLayout />}>
                    <Route path={ROUTES.HOME} element={<CaptureView />} />
                    <Route path={`${ROUTES.NOTES}/:id`} element={<NoteDetailView />} />
                    <Route path={ROUTES.SEARCH} element={<SearchView />} />
                    <Route path={ROUTES.CATEGORIES} element={<CategoriesView />} />
                    <Route path={ROUTES.MORE} element={<MoreView />} />
                    <Route path={ROUTES.BIN} element={<BinView />} />
                </Route>

                {/* Default Redirect */}
                <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
            </Routes>
        </Suspense>
    );
}
